import { path } from 'ramda';

const addSmsMessageListener = (windowArg, getLinkApi: Promise<any>, originAllowed: string): void => {
    if (!windowArg || typeof getLinkApi !== 'function') {
        return;
    }
    windowArg.addEventListener('message', (event: { source; origin; data }): void => {
        if (event.origin.includes(originAllowed) && event.data && event.data.includes && event.data.includes('"type":"getlink"')) {
            try {
                const data = JSON.parse(event.data);
                const type = path(['type'], data);
                const phone = path(['value'], data);
                const id = path(['id'], data);

                const respData = {
                    type,
                    id,
                    error: '',
                };
                // @ts-ignore
                getLinkApi(phone)
                    .then((): void => event.source.postMessage(JSON.stringify(respData), event.origin))
                    .catch((error): void => {
                        respData.error = error.toString();
                        event.source.postMessage(JSON.stringify(respData), event.origin);
                    });
            } catch (error) {
                event.source.postMessage(JSON.stringify({ error }), event.origin);
            }
        }
    });
};

export { addSmsMessageListener };
